import React from "react";

const Komoditas = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Komoditas"
        src="https://lookerstudio.google.com/embed/reporting/caeb3756-653b-444a-8d74-7e5b813df4da/page/daSTD"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Komoditas;
